import * as React from 'react';
import { hasAddPermission, hasReadPermission } from '../../service/userService';
import { SuperAdminInfo } from '../common/ShowAdminInfo';
export interface ISystemPanelProps {
    label?: string;
    //children?: React.ReactNode;
    showAdd?: boolean;
    onAdd?(): void;

    showRefresh?: boolean;
    onRefresh?(): void;

    showArchive?: boolean;
    onArchive?(): void;

    showCollapse?: boolean;
    onCollapse?(): void;

    showSearch?: boolean;
    onSearch?(): void

    showClear?: boolean;
    onClear?(): void;

    panelWidth?: number;
    panelHeight?: number;
    key?: string;
    panelColumn?: number;
    panelRow?: number;
    tilePanel?: any;
    draggable?: boolean;
    CollapseButtonText?: string;
    CollapseButtonOrIcon?: boolean
    toolbar?: any[]
    collapse?: boolean
    style?: React.CSSProperties;
    AddButtonDisable?: boolean
    securityObject?: string,
    showAddbuttonOnForm?: boolean;
    disabled?: boolean,
}

export class SystemPanel extends React.PureComponent<ISystemPanelProps, any, any> {
    static defaultProps = {
        showAdd: true,
        showRefresh: true,
        showReview: true,
        showArchive: true,
        showCollapse: true,
        panelWidth: 4,
        panelHeight: 1,
        panelColumn: 1,
        panelRow: 1,
        collapse: false,
        showAddbuttonOnForm: true
    }


    constructor(props: any) {
        super(props)
        this.state = {
            isCollapse: this.props.CollapseButtonText == 'Create Encounter' || this.props.collapse ? true : false,
            CollapsButtonOrIcone: false,
        }
    }

    onCollapse = () => {
        this.setState({ isCollapse: !this.state.isCollapse })
    }

    onRefresh = () => {

        if (this.props.onRefresh) this.props.onRefresh()
    }

    render() {
        var widthClass = ""
        switch (this.props.panelWidth) {
            case 1: widthClass = "mb-3"; break;
            case 2: widthClass = "tiles-grid col-md-6  mb-3"; break;
            case 4: widthClass = "tiles-grid col-md-12  mb-3"; break;
        }


        let canAdd = hasAddPermission(this.props.securityObject);
        let canRead = hasReadPermission(this.props.securityObject);
        return (
            <>
                <div className={["tiles", widthClass].join(" ")}
                    style={this.props.disabled ? { pointerEvents: "none", opacity: "0.4", ...(this.props.style || {}) } : {}}>
                    {this.props.label ?
                        (<><div className="tiles-top-sec" onClick={this.onCollapse}>
                            <div className="tiles-top-sec-left">
                                <h4><SuperAdminInfo {...this.props} /></h4>
                            </div>
                            <div className="tiles-top-sec-right p-0" onClick={(event) => {
                                event.stopPropagation()
                            }}>
                                {this.props.toolbar && this.props.toolbar.length > 0 && this.props.toolbar}
                                {this.props.showSearch && <button onClick={this.props.onSearch} className="btn btn-default" title="Search"><span className="icon-search"></span>Search</button>}
                                {this.props.showClear && <button onClick={this.props.onClear} className="btn btn-default" title="Clear"><span className="icon-refresh"></span>Clear</button>}
                                {this.props.showArchive && <button onClick={this.props.onArchive} className="btn btn-default"><span className="icon-add-box"></span>Archive Data</button>}
                                {this.props.showAdd && this.props.showAddbuttonOnForm && <button disabled={!canAdd || this.props.AddButtonDisable} onClick={this.props.onAdd} className="btn btn-default" title={canAdd ? "Add record" : "You dont have permission to add record"}><span className="icon-add"></span>Add</button>}
                                {this.props.showRefresh && <button onClick={this.props.onRefresh} className="btn btn-default" title="Reload"><span className="icon-refresh"></span> Reload</button>}
                                {this.props.showCollapse && <button onClick={this.onCollapse} title="Collapse Panel" className={"panel-collapse-btn"}>
                                    {this.props.CollapseButtonOrIcon == true ? <span className="btn btn-default" >{this.props.CollapseButtonText}</span>
                                        :
                                        (this.state.isCollapse == false) ? <span className="icon-arrow_up"></span> : <span className="icon-arrow_down"></span>
                                    }
                                </button>
                                }

                            </div>
                        </div>
                            <div className={"tiles-btm-sec popup-scroll-control " + (this.state.isCollapse ? "grid-collapsed" : "")} >
                                {canRead ? this.props.children : <div>You dont have permission to read this object</div>}
                            </div>

                        </>) :
                        this.props.children}
                </div>
            </>
        )
    }
}
